import { useEffect, useState } from "react";
import AlertNotification from "components/CustomWidgets/alertNotification";
const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      AlertNotification("success", "You are back online");
    };

    const handleOffline = () => {
      setIsOnline(false);
      AlertNotification(
        "error",
        "You are offline. Check your internet connection.",
      );
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return null;
};

export default NetworkStatus;
